export default __webpack_public_path__ + "resources/icons/d311-1c7d.webp";